export default __webpack_public_path__ + "static/media/bookcover - front.11fbf5bf.png";